// Copyright (c) 2020 embyt GmbH. All rights reserved.
// Author: Roman Morawek

import {
  AlarmNotification,
  CloudSettings,
  IUserChargingControl,
  Report,
  UserAccessRights,
  UserSettings,
} from "shared/types/cloudtypes";
import { DeviceType } from "shared/types/globtypes";

export interface Site {
  id: number;
  name: string;
  serial: string;
  companyId: number;
  deviceType: DeviceType;
  deviceSw: string | undefined;
  tzOffset: number | undefined;
  ipAddresses: string | undefined;
  cloudSettings: CloudSettings | undefined;
  longitude: number | undefined;
  latitude: number | undefined;
  unackAlarms: number | undefined;
  unclearedAlarms: number | undefined;
}

export interface AwsUser {
  secId?: string;
  isRfidUser: boolean;
  email?: string;
  realName?: string;
}

export interface Company {
  id: number;
  name: string;
  parentId: number | null;
}

export interface User {
  id: number;
  secId: string;
  email: string;
  name: string;
  companyId: number;
  accessRights: UserAccessRights;
  // extended data, only available after extended request
  settings?: UserSettings | undefined;
  siteIds?: number[];
  chargingControl?: IUserChargingControl | undefined;
}

export interface IStateSite {
  user: AwsUser | undefined;
  siteList: Site[] | undefined;
  userList: User[] | undefined;
  companyList: Company[] | undefined;
  alarmNotificationList: AlarmNotification[] | undefined;
  // the data reports of the logged-in user, covering all of its sites
  reportList: Report[] | undefined;
  tzOffset: number | undefined;
}

/* initial state */
export const INITIAL_STATE: IStateSite = {
  user: undefined,
  siteList: undefined,
  userList: undefined,
  companyList: undefined,
  alarmNotificationList: undefined,
  reportList: undefined,
  tzOffset: undefined,
};
